"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TOP_POSTS_LIMIT = exports.TOP_POST_SORTS = void 0;
/**
 * Which engagement metric ranks the Top Performing Posts table.
 *
 * The RANKING happens server-side, per metric, which is the only way "top 5 by shares" can be
 * right: re-sorting a top-5-by-likes list client-side reorders those five posts, and the five most
 * shared posts are a different five. So a sort change is a different query, not a different view of
 * the same rows.
 */
exports.TOP_POST_SORTS = ['likes', 'comments', 'shares'];
/** How many posts the table shows. Fewer are returned when fewer qualify — never padded. */
exports.TOP_POSTS_LIMIT = 5;
//# sourceMappingURL=analytics.js.map